module.exports = __webpack_public_path__ + "static/media/Chlodzenie2.a8b11e70.svg";